/**
 * Implements a placeholder for CEX
 */
import { useEffect, useRef, useState } from 'react';
import Text from '../../../atoms/Text';
import { ReactComponent as SkeletonNormal } from '../images/skeleton_normal.svg';

interface ITradingPlaceholderProps {
  text: string;
  height: string | number;
}

const TradingPlaceholder = ({ text, height }: ITradingPlaceholderProps) => {
  const [scroll, setScroll] = useState(false);
  const placeholder = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (placeholder.current) {
      setScroll(placeholder.current.clientHeight < 445);
    }
  }, [placeholder]);

  return (
    <div className='trading' style={{ flexBasis: height }} ref={placeholder}>
      <div className='container'>
        <div className='row tab_selector'>
          <div className='row'>
            <div className='tab'>
              <Text size={12}>Swap</Text>
            </div>
          </div>
          <div className='row'></div>
        </div>
        {!scroll && (
          <div className='skeleton'>
            <SkeletonNormal />
          </div>
        )}
        <div className='placeholder__text'>
          <Text size={12}>{text}</Text>
        </div>
      </div>
    </div>
  );
};

export default TradingPlaceholder;
